var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.123047,
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_312_6587",
    transform: "scale(0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_312_6587",
    width: 45,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAEWUlEQVRoBdWZW2/TSBTH88YH4IUnPgR8D55wykWwSIiKB5BgV1wErJZnkLjUk9IgIVixXHaB7qoSZcUDlwcaJCJU2oJAaJfuplyEQNya40vqHPQf21Hj2ONL4lS1FFm2xzO/OTnzP2eOC4Uuj23n51cVS8aOoqiPaILGNEHVok5vNEGWd67iPp6jHdp3OWS217eUjdVFQQc0nSY0QU1Nr3Pin2xPE3gf/WQjSPHW1l+/rlyvz5+AFRNDqiYkyEJ/6DcFRrKmu8d5xUDJOFgUxueewAYmgn7RP8ZJRhTTCj6o6VTJA7azT6p07fMDZXuNplOts/MUPhywanxfVMO4MbYMf6zp5jpNJ4ofJI8JYFxzXThZxF1tuL526YB9IxAltrjnw312CR80eKZarI9j9fZv0QUBo66polQVyM7S+HAUsHsfXKGeDIHPS4fDDLGhRLz7N+KtZyk2moIrNADJSJdantQWCoPFPQCLOxY/qS3w6GObd16IBwdfm7WRA/QsNMdM3Af+973DDYf5i9HksUkPfGg+2uqCrLZcxU1+slktypph933gVx9cYPYOgN+esXnDsWfR0Hqdwdmydj8UY+Ow6xKzAWBw2wvM49M2bzz+QgkNTgktdTltehnjAkErA7h0x+Io4L9nbP7xCrF2+pMaWlBT6rYmzMHgIL28BvDwXTXwnsskF2eScbGRKGjCKCdp/MNZ4mPjJu/73WCAJHkH7c4ogG9N25wGWI4pjHJBbpFi/u7t54ivPbL5v4+OlKmjf5mx4C3gjw4vOP6Sc8/w4UzA4BQ0Buiqymqbht7xzSmbP3xrstNkKVMzcw7/8mc0eG7ALnS1IDefCksPnpqUwM1FxoK+Ts85/PNoJziAR+5ZPNtrC3uM4IWllfu9zUNv+f6LBpO9iNqTKUS0wzeM1iLadEYNDFlL7cNBgwqyYi2tDc3z3svED1422AgBn/y/wYeuG7ylTFy+Z0m/D/PhngAjwHiWVvo0/L0oiH+6SvzwnwabjU6Lw8fvPm/w3KfwRecDD5SSqY5qjWENJlIPdIIB9/9hcHW2wVYAHD5u2iwX6uIp+ZFuzyWS7ythgm4QdQ31kJWhqAaB+8gd4ApwCQCpjlyA5b9eHykgwqSxAMChGlO1BSl/YeB5AYNTRsQsuQdkDTo987o9W8MEJPCUzT11Cf8f93MPZE1Zsjwf/Oki8FyBJThNtFLTrPk0dBkh/dlrR+r4eF4W9izdlk93s3MB+JFRk0/etnjXxR6qhO8S/jm4c4HJu9kjYnFuHiGp52kWdZq2HXtEQPd7N54GOHI3DvBlV/cA9LKsMAFc6nbfy7tRlYAEtTxA4/Dq0ktU5vUnkKJq6nEXll19ugXu1qn7XPalGurjPkOms+fjy+ebiz9LqArkMK+qKvpF/8o6tA+T9owAJCNnzL4yceDI8zticHLIVdwkiyoZv9hW8H5bFTQ4SJ7Xbj5uDspKleLbOJ736tv4dx4o8iDbAvJKAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.b26e7993d221412dc839a6b7273fa5ee.svg";
export { ForwardRef as ReactComponent };